import get from 'lodash/fp/get';
import { createSelector } from 'reselect';

const selectAppSnackbar = (state) => get('app', state);

const selectSnackbarData = createSelector(selectAppSnackbar, (app) => app.snackbar);
export default selectSnackbarData;
